export default function HorizontalLine() {
  return (
    <hr className="h-px my-4 bg-gray-300 border-0 dark:bg-gray-700"/>
  )
}
